module.exports = __webpack_public_path__ + "svgs/abolished.78f3cacb.svg";